import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as wizeMobileApi from '@wize-mobile-api';
import { Observable, of } from 'rxjs';
import { switchMap, takeWhile, withLatestFrom } from 'rxjs/operators';
import { selectIsAuthenticated } from '@qvs/core/auth';
import { hasCrmRole } from '@qvs/core/user';
import { PortfolioMandateType } from '@qvs/core';
import { MandateTypeMapper } from '~/modules/mandateTypes/mandateType.mapper';
import { loadMandateTypes } from '~/modules/mandateTypes/slice/mandateType.actions';

@Injectable({
  providedIn: 'root'
})
export class MandateTypeService {
  constructor(
    private readonly store: Store,
    private readonly wizeMandateTypesService: wizeMobileApi.MandateTypeService
  ) {}

  public loadMandateTypes = (): Observable<PortfolioMandateType[]> =>
    this.wizeMandateTypesService
      .listMandateTypes()
      .pipe(switchMap((wizeMandateTypes) => of(MandateTypeMapper.fromWizeMandateTypes(wizeMandateTypes))));

  public init = (): Promise<void> => {
    this.store
      .select(selectIsAuthenticated)
      .pipe(
        withLatestFrom(this.store.select(hasCrmRole)),
        takeWhile(([isAuthenticated, isCrm]) => isAuthenticated && !isCrm)
      )
      .subscribe(() => this.store.dispatch(loadMandateTypes()));
    return Promise.resolve();
  };
}
